import React from 'react'
import { BrushIcon, NotificationIcon, SettingIcon, UserIcon } from '../iconSet/IconSet'
import { useTheme } from '../../context/ThemeContext'
import { ThemeTypes } from '../../context/ContextTypes'
import { useNavigate } from 'react-router-dom'
import { HeaderPropsType } from './HeaderTypes'

import logo from '../../images/icons/logo.png'
import ToggleSwitch from '../toggleSwitchComp/ToggleSwitch'

const Header = (props: HeaderPropsType) => {
    const navigate = useNavigate()
    
    // Theme context
    const {theme, setTheme} = useTheme()


    // Handle theme change button click
    const handleThemeChangeClick = (type: ThemeTypes) => {
        setTheme(prevState => type)
    }
    
    /* Handle navigate */
    const handleNavigate = (link: string) => {
        navigate(link)
    }

    // Handle user icon click
    const handleUserIconClick = () => {
        props.userMenuStatus(prevState => !prevState)
    }

    // Handle theme icon click
    const handleThemeIconClick = () => {
        props.themeMenuStatus(prevState => !prevState)
    }

    return (
        <div className={`header-wrapper`}>
            <div className={`left-side`}>
                
                <div className={`expand-btn-wrapper`}>
                    {/* <MenuExpandIcon className='icon' width='2rem' color='var(--color-text)'/> */}
                    <div className={`title`} onClick={(e) => handleNavigate('/')} style={{cursor: 'pointer'}}>
                        <img src={logo} alt="" />
                        <span>BCONX</span>
                    </div> 
                </div>
            </div>
            <div className={`right-side`}>
                {/* {theme === 'dark' ? (
                <div className={`theme-button-wrapper`} onClick={(e) => handleThemeChangeClick('light')}>
                    <LightModeIcon color='var(--color-text)' width='1.2rem' />
                </div>) : theme === 'light' ? (
                    <div className={`theme-button-wrapper`} onClick={(e) => handleThemeChangeClick('dark')}>
                    <DarkModeIcon color='var(--color-text)' width='1rem' />           
                    </div>
                ) : null} */}

                <div className={`user-button-wrapper`}>
                    <ToggleSwitch width={2} backgroundColor='var(--color-side-menu-bg)' rightLabel='Test' leftLabel='Production' rightActiveColor='var(--color-main-green)' leftActiveColor='var(--color-main-red)' />
                </div>
                <div className={`theme-button-wrapper`} onClick={() => handleThemeIconClick()}>
                    <BrushIcon color='var(--color-text)' width='1.2rem' />
                </div>
                {/* <div className={`notification-button-wrapper`}>
                    <NotificationIcon color='var(--color-text)' width='1.7rem'/>
                </div> */}
                <div className={`setting-button-wrapper`} onClick={(e) => handleNavigate('/settings/theme_settings')}>
                    <SettingIcon color='var(--color-text)' width='1.2rem'/>
                </div>
                <div className={`user-button-wrapper`} onClick={() => handleUserIconClick()}>
                    <UserIcon color='var(--color-text)' width='1.2rem'/>
                </div>
            </div>
        </div>
    )
}

export default Header